import { CLIENT_SETTINGS } from 'constants/clientSettings'
import React from 'react'

import Icon, { IconProps } from './Icon'

/**
 * 落輪・乗り上げ
 */
const FallingWheelIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
      >
        <g transform="translate(-272 2692)">
          <rect
            width="40"
            height="40"
            rx="6"
            transform="translate(272 -2692)"
            fill={CLIENT_SETTINGS.colors.background}
          />
          <g transform="translate(276 -2681.5)">
            <rect
              width="13.309"
              height="1.611"
              rx="0.805"
              transform="translate(9.201 21.813)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <rect
              width="3.154"
              height="1.611"
              rx="0.805"
              transform="translate(31.53 21.813)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <rect
              width="5.154"
              height="1.611"
              rx="0.805"
              transform="translate(-2.684 21.813)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <rect
              width="36.08"
              height="1.289"
              rx="0.644"
              transform="translate(-1.718 24.39)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <rect
              width="32.214"
              height="0.644"
              rx="0.322"
              transform="translate(-0.107 26.968)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <path
              d="M3.031,1.522a1,1,0,0,1,1.737,0L6.945,5.336a1,1,0,0,1-.869,1.5H1.722a1,1,0,0,1-.869-1.5Z"
              transform="translate(23.121 16.592)"
              fill={CLIENT_SETTINGS.colors.main}
            />
            <path
              d="M22.269,1.413A2.09,2.09,0,0,0,20.282,0H4.9A2.1,2.1,0,0,0,2.909,1.413L0,9.792v11.19a1.4,1.4,0,0,0,1.4,1.4H2.8a1.4,1.4,0,0,0,1.4-1.4v-1.4H20.982v1.4a1.4,1.4,0,0,0,1.4,1.4h1.4a1.4,1.4,0,0,0,1.4-1.4V9.792ZM4.9,15.387a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,4.9,15.387Zm15.387,0a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,20.282,15.387ZM2.8,8.393,4.9,2.1H20.282l2.1,6.295Z"
              transform="matrix(0.966, -0.259, 0.259, 0.966, -1.433, 0.716)"
              fill={CLIENT_SETTINGS.colors.main}
            />
          </g>
        </g>
      </svg>
    </Icon>
  )
}

export default FallingWheelIcon
